import { IntegrationCodeStatus } from "../types/equipmentModelIntegrationCode"

export const integrationStatusLabels: Record<IntegrationCodeStatus, string> = {
  link_in_progress: 'Homologação em andamento',
  with_link: 'Concluído',
  failed_on_linking: 'Falha na homologação',
}

export const integrationStatusColorClass: Record<IntegrationCodeStatus, string> = {
  link_in_progress: 'text-yellow-400',
  with_link: 'text-valid',
  failed_on_linking: 'text-danger-soft',
}

export const integrationProviderLabels: Record<string, string> = {
  tec_alliance: 'TecAlliance',
}
